export const plannerRootEn = {
  status: {
    loading: 'Loading board…',
    liveSyncLost: (error: string) => `Live board sync lost — changes may not be saved (${error})`,
    liveSyncLostAria: 'Live board sync lost — changes may not be saved',
    viewOnly: "View-only — only officers and the Discord owner can edit this guild's board.",
    oldRaidReadOnly: 'Historical raid — only the super admin can edit it.',
  },
  announcement: {
    sortedByRole: 'Sorted every group by role',
    resetToSeed: 'Board reset to seed data',
    viewChanged: (mode: string) => `View: ${mode}`,
    allStages: 'Viewing all stages',
    stageSelected: (stageId: string) => `Viewing stage ${stageId}`,
    stageAdded: (stage: string) => `Added ${stage} stage`,
    stageChangesReset: 'Reset the selected stage changes',
    allStageChangesReset: 'Reset all stage changes',
  },
  stageKind: {
    forest: 'Forest',
    towers: 'Towers',
    goose: 'Goose',
    tree: 'Tree',
    custom: 'Custom',
    opening: 'Opening',
  },
}
